import { Status } from './status';

export class Module {
  id: number;
  code: string;
  name: string;
  status: Status = new Status();
  createdAt: Date = new Date();
  updatedAt: Date;
}
